import useGlobalStore from '@/store/useGlobalStore'

import T from '@/components/Helpers/Translate'

export const CheckoutFooter = () => {
  const { app } = useGlobalStore()

  const currentYear = new Date().getFullYear()

  return (
    <div className="flex justify-center bg-primary text-white">
      <div className="flex w-full max-w-[1200px] flex-col items-center space-y-3 p-3 py-5 text-center text-sm lg:flex-row lg:justify-between lg:space-y-0">
        <div className="">
          © {currentYear} <T>copyright</T>
        </div>
        <div className="flex">
          <a
            href={`https://www.unicity.com/${app.alpha3}/${app.language}/privacy-policy`}
            target="_blank"
            rel="noreferrer"
          >
            <T>privacy_policy</T>
          </a>
          <p className="mx-2.5">|</p>
          <a
            href={`https://www.unicity.com/${app.alpha3}/${app.language}/terms-of-use`}
            target="_blank"
            rel="noreferrer"
          >
            <T>terms_of_use</T>
          </a>
        </div>
      </div>
    </div>
  )
}
